module.exports = __webpack_public_path__ + "static/media/AProjectbyPastel.03930fee.svg";